export default function (cartItem) {
  for (const property in cartItem) {
    if (property === "person") {
      if (
        cartItem.dimensionObjectfirstname &&
        cartItem.dimensionObjectlastname &&
        cartItem[property].dimensionObjectID !== 0
      ) {
        cartItem.person = `${cartItem.dimensionObjectfirstname} ${cartItem.dimensionObjectlastname}`
      } else {
        cartItem.person = null
      }
    }

    if (
      (property === "person" && cartItem[property] === null) ||
      cartItem[property] === undefined
    ) {
      cartItem.person = ""
      cartItem.employee = ""
    }
  }

  return cartItem
}
